import { FC, useState } from 'react'
import Button from '@UI/New/Button'
import { PlusCircleFilled } from '@ant-design/icons'
import SetCourseClassDirectionModal from './components/SetCourseClassDirectionModal'
import { Lead } from '@/api/types/crm.types'
import CourseClassList from './components/CourseClassList/CourseClassList'
import { Empty } from 'antd'
import { useLeadRefetch } from '../../LeadRefetchContext'
import { useAsyncRetry } from 'react-use'
import { classApi, crmApi, directionOrdersApi } from '@/api'
import { useLeadStatuses } from '../../blocks/StatusListBlock/LeadStatusContext'
import classes from './index.module.css'
import useFullLeadModalAccess from '../../hooks/useFullLeadModalAccess'

interface PurchasesBlockProps {
  lead: Lead
  excludedClassIds: number[]
  excludedDirectionIds: number[]
  refetchExcludedIds: () => void
}

const PurchasesBlock: FC<PurchasesBlockProps> = ({
  lead,
  excludedClassIds,
  excludedDirectionIds,
  refetchExcludedIds,
}) => {
  const [stateModal, setStateModal] = useState<{
    open: boolean
    type?: 'add'
  }>({
    open: false,
    type: 'add',
  })
  const { refreshStatuses } = useLeadStatuses()
  const { handleRefetchLeadInModal, handleRefetchLeadsOnClose } =
    useLeadRefetch()
  const { currentRole, ...access } = useFullLeadModalAccess()

  // prettier-ignore
  const paymentState = useAsyncRetry(
    async () => lead?.user_id ? await crmApi.getLeadPayments({ user_id: lead.user_id }) : null,
    [lead?.user_id],
  )
  const paymentData = {
    classes: paymentState.value?.data?.data?.classes || [],
    directions: paymentState.value?.data?.data?.directions || [],
  }

  const handleRefetchPaymentData = () => {
    paymentState.retry()
    refreshStatuses()
    handleRefetchLeadsOnClose()
    refetchExcludedIds()
  }

  return (
    <div className={classes.card}>
      <div className={classes.cardHeader}>
        <p className={classes.cardTitle}>Курсы / Классы / Траектории</p>
        {access.canAddPurchases && (
          <Button
            color="white"
            onClick={() => setStateModal({ open: true, type: 'add' })}
            rightContent={
              <PlusCircleFilled
                className={classes.iconPlusCircleFilled}
                onPointerEnterCapture={undefined}
                onPointerLeaveCapture={undefined}
              />
            }
          >
            Добавить покупку
          </Button>
        )}
      </div>
      {lead.user_id ? (
        <div className={classes.cardContent}>
          <CourseClassList
            userId={lead.user_id}
            loading={paymentState.loading}
            paymentData={paymentData}
            refetchPaymentData={handleRefetchPaymentData}
          />
        </div>
      ) : (
        <div className={classes.cardContent}>
          <Empty
            className={classes.empty}
            image={Empty.PRESENTED_IMAGE_SIMPLE}
            description={
              'Лид пока ещё не привязан ни к одному личному кабинету, поэтому у него нет покупок'
            }
          />
        </div>
      )}

      {/* Modals */}
      <SetCourseClassDirectionModal
        lead={lead}
        userId={lead?.user_id ?? null}
        excludedClassIds={excludedClassIds}
        excludedDirectionIds={excludedDirectionIds}
        open={stateModal.open && stateModal.type === 'add'}
        onClose={() => setStateModal({ open: false })}
        onSuccess={() => {
          handleRefetchLeadInModal()
          handleRefetchPaymentData()
          setStateModal({ open: false })
        }}
      />
    </div>
  )
}

export default PurchasesBlock
